import {Injectable} from '@angular/core';
import {GenericService} from "../../core/commons/generic.service";
import {Ministry} from "../domain/ministry/ministry";
import {QueryOptions} from "../../core/commons/query.options";
import {AuthService} from "../../core/security/auth.service";
import {environment} from "../../../environments/environment";
import {RequestMethod} from "@angular/http";
import {Observable} from "rxjs/Observable";
import {PaginationPage} from "../../core/commons/pagination-page";
import {User} from "../../core/domain/user";

@Injectable()
export class MinistryService extends GenericService<Ministry> {

    constructor(authService: AuthService) {
        super(authService);
    }

    protected valueToEntity(value: Object): Ministry {
        return new Ministry(value);
    }

    protected getResourcePath(): string {
        return '/ministries';
    }

    getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

    public publicFindAll(): Observable<Ministry[]> {
        let req = this.buildRequest(RequestMethod.Get);
        return this.authService.publicRequest(environment.backendHost + environment.backendPublicApiPath + "/ministry/all", req)
            .map(res => res.json().map( t => this.valueToEntity(t) ) );
    }

    public pagedSearch(terms: string,
                       queryOptions: QueryOptions = this.getDefaultQueryOptions()): Observable<PaginationPage<Ministry>> {
        const ro = queryOptions.getQueryRequestOptions().merge({
            url: this.baseUrl + this.getResourcePath() + '/search'});
        if (terms) {
            ro.params.append('terms', terms)
        }

        return this.doRequest(ro)
            .map(res => res.json())
            .concatMap(json => Observable.from(json.content)
                .concatMap(value => this.mapValueToEntityQuery(value))
                .toArray()
                .map(content => new PaginationPage({...json, content: content}))
            );
        /*
        return this.doRequest(queryOptions.getQueryRequestOptions().merge({
            url: this.baseUrl + this.getResourcePath()
        }))
            .map(res => res.json())
            .concatMap(json => Observable.from(json.content)
                .concatMap(value => this.mapValueToEntityQuery(value))
                .toArray()
                .map(content => new PaginationPage({...json, content: content}))
            );*/
    }

}



// WEBPACK FOOTER //
// ./src/app/profile/service/ministry.service.ts